import { createSelector } from '@reduxjs/toolkit';

import { selectIsCpcAuctionEnabled } from '../selectIsCpcAuctionEnabled';
import { selectOffer } from './selectOffer';

export const selectIsCpcOffer = createSelector(selectIsCpcAuctionEnabled, selectOffer, (isCpcAuctionEnabled, offer) => {
  return isCpcAuctionEnabled && !!offer.promotion?.isCpcAuction;
});
